import component from './en-US/component';
import globalHeader from './en-US/globalHeader';
import menu from './en-US/menu';
import pages from './en-US/pages';
import pwa from './en-US/pwa';
import settingDrawer from './en-US/settingDrawer';
import settings from './en-US/settings';
import fixAdminMisc from './en-US/fix_adminmisc';
import fixBilling from './en-US/fix_billing';
import fixComponents from './en-US/fix_components';
import fixConsoleMisc from './en-US/fix_consolemisc';
import fixGap from './en-US/fix_gap';
import fixSystemconfig from './en-US/fix_systemconfig';
import fixTenant from './en-US/fix_tenant';
import fixVoiceClone from './en-US/fix_voiceclone';
import fixOpenapi from './en-US/fix_openapi';
import fixTodo from './en-US/fix_todo';
import fixLedger from './en-US/fix_ledger';

export default {
  'navBar.lang': 'Languages',
  'layout.user.link.help': 'Help',
  'layout.user.link.privacy': 'Privacy',
  'layout.user.link.terms': 'Terms',
  'app.preview.down.block': 'Download this page to your local project',
  'app.welcome.link.fetch-blocks': 'Get all block',
  'app.welcome.link.block-list':
    'Quickly build standard, pages based on `block` development',

  ...globalHeader,
  ...menu,
  ...settingDrawer,
  ...settings,
  ...pwa,
  ...component,
  ...pages,
  ...fixConsoleMisc,
  ...fixComponents,
  ...fixAdminMisc,
  ...fixBilling,
  ...fixTenant,
  ...fixVoiceClone,
  ...fixGap,
  ...fixSystemconfig,
  ...fixOpenapi,
  ...fixTodo,
  ...fixLedger,
};
